import { Injectable, NgZone } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { environment } from '../environments/environments';

@Injectable({
  providedIn: 'root',
})
export class AumyeRealTimeNotificationService {
  private eventSource: EventSource | null = null;
  private events = new Subject<EventMessage>();
  private reconnectAttempts = 0;
  private maxReconnectAttempts = 5;
  private reconnectDelay = 3000;

  constructor(private ngZone: NgZone) {}

  connect(): Observable<EventMessage> {
    this.setupEventSource();
    return this.events.asObservable();
  }

  private setupEventSource(): void {
    if (this.eventSource) {
      this.eventSource.close();
    }

    this.ngZone.runOutsideAngular(() => {
      this.eventSource = new EventSource(
        `${environment.apiUrl}${'SSEEndpoint'}`
      );

      this.eventSource.onmessage = (event) => {
        this.ngZone.run(() => {
          try {
            const data = JSON.parse(event.data);
            this.events.next(data);
            this.reconnectAttempts = 0; // Reset reconnect attempts on successful connection
          } catch (error) {
            console.error('Error parsing SSE data:', error);
          }
        });
      };

      this.eventSource.onerror = (error) => {
        this.ngZone.run(() => {
          console.error('SSE connection error:', error);
          this.eventSource?.close();
          this.handleReconnection();
        });
      };
    });
  }

  private handleReconnection(): void {
    if (this.reconnectAttempts < this.maxReconnectAttempts) {
      this.reconnectAttempts++;
      console.log(
        `Attempting to reconnect (${this.reconnectAttempts}/${this.maxReconnectAttempts})...`
      );

      setTimeout(() => {
        this.setupEventSource();
      }, this.reconnectDelay * this.reconnectAttempts);
    } else {
      this.events.error(new Error('Maximum reconnection attempts reached'));
    }
  }

  disconnect(): void {
    if (this.eventSource) {
      this.eventSource.close();
      this.eventSource = null;
    }
  }
}
export interface EventMessage {
  type: string;
  message: string;
  timestamp: Date;
}
